import React from "react";
import "./apartment.scss";
import Slider from "react-slick";
import Primroseimages from "./primerose";
import Produk from "./produk/produk.jsx";
import Springlakeimages from "./springlake.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const apartment = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768, // Adjust breakpoint for your mobile size
        settings: {
          slidesToShow: 1, // Show only 1 slide on mobile screens
        },
      },
    ],
  };
  return (
    <div id="apart" className="container-apartment">
      <div className="devider">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="divider-img-691399"
          viewBox="0 0 1010 137"
          preserveAspectRatio="none"
        >
          <path
            d="M 0,137 V 59.03716 c 158.97703,52.21241 257.17659,0.48065 375.35967,2.17167 118.18308,1.69101 168.54911,29.1665 243.12679,30.10771 C 693.06415,92.25775 855.93515,29.278599 1080,73.61449 V 137 Z"
            style={{ opacity: "1" }}
          ></path>
          <path
            d="M 0,10.174557 C 83.419822,8.405668 117.65911,41.78116 204.11379,44.65308 290.56846,47.52499 396.02558,-7.4328 620.04248,94.40134 782.19141,29.627636 825.67279,15.823104 1080,98.55518 V 137 H 0 Z"
            style={{ opacity: 0.5 }}
          ></path>
          <path
            d="M 0,45.10182 C 216.27861,-66.146913 327.90348,63.09813 416.42665,63.52904 504.94982,63.95995 530.42054,22.125806 615.37532,25.210412 700.33012,28.295019 790.77619,132.60682 1080,31.125744 V 137 H 0 Z"
            style={{ opacity: 0.25 }}
          ></path>
        </svg>
      </div>
      <div className="judul-apartment">
        <h1 id="apartment">APARTMENT</h1>
      </div>
      <div className="container-desk-apartment">
        <div className="carousel-primerose">
          <div>
            <Slider {...settings}>
              {Primroseimages.map((image, index) => (
                <div>
                  <img
                    className="image-apartment"
                    key={index}
                    src={image}
                    alt="foto Banner"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="carousel-primerose">
          <div>
            <Slider {...settings}>
              {Springlakeimages.map((image, index) => (
                <div>
                  <img
                    className="image-apartment"
                    key={index}
                    src={image}
                    alt="foto Banner"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      <div className="container-produk">
        <Produk />
      </div>
    </div>
  );
};

export default apartment;
